/**
 * Converts Contentful's "Manifesto" content type to the appropriate component
 *
 * Copyright (c) 2020 Coursera
 * Author: Kelvin Nguyen
 */
import React from 'react'
import PropTypes from 'prop-types'
import Manifesto from 'components/Manifesto'
import { convertRichTextToComponent } from '../utils'

const ContentfulManifesto = ({
  manifestoTitle, backgroundColor, content,
}) => (
  <Manifesto
    title={manifestoTitle}
    backgroundColor={backgroundColor}
    content={convertRichTextToComponent(content)} />
)

ContentfulManifesto.propTypes = {
  manifestoTitle: PropTypes.string,
  content: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  backgroundColor: PropTypes.string,
}

export default ContentfulManifesto
